export default "__VITE_ASSET__aZW8Jede__"